// Copyright (c) 2016 Deere & Company

import LaborStatsReport from '../../../reports/labor-stats/state-connector';

export default {
    component: LaborStatsReport,
    name: 'LABOR_STATS',
    path: 'labor-stats'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/labor-stats.js